import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Home,
  ShoppingCart,
  Wallet,
  FileText,
  Users,
  RotateCcw,
  Settings,
  Code,
  Megaphone,
} from 'lucide-react';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
} from '@/components/ui/command';

/**
 * CommandMenu - ShadCN Command palette for quick navigation
 * Opens with Cmd+K or by clicking the search button
 */
const CommandMenu = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  const handleSelect = (href) => {
    onOpenChange(false);
    
    // Handle external links
    if (href.startsWith('http')) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    
    navigate(href);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Type a command or search..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        
        {/* Quick Navigation */}
        <CommandGroup heading="Navigation">
          <CommandItem onSelect={() => handleSelect('/home')}>
            <Home className="mr-2 h-4 w-4" />
            <span>Home</span>
            <CommandShortcut>⌘H</CommandShortcut>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('/orders')}>
            <ShoppingCart className="mr-2 h-4 w-4" />
            <span>Orders</span>
            <CommandShortcut>⌘O</CommandShortcut>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('/payouts')}>
            <Wallet className="mr-2 h-4 w-4" />
            <span>Payouts & Balances</span>
            <CommandShortcut>⌘P</CommandShortcut>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('/customers')}>
            <Users className="mr-2 h-4 w-4" />
            <span>Customers</span>
            <CommandShortcut>⌘U</CommandShortcut>
          </CommandItem>
        </CommandGroup>
        
        <CommandSeparator />
        
        {/* Reports */}
        <CommandGroup heading="Reports">
          <CommandItem onSelect={() => handleSelect('/reports')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Reports Overview</span>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('/transaction-report')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Transaction Report</span>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('/store-credit-report')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Store Credits</span>
          </CommandItem>
        </CommandGroup>
        
        <CommandSeparator />
        
        {/* Other */}
        <CommandGroup heading="Other">
          <CommandItem onSelect={() => handleSelect('/manual-refunds')}>
            <RotateCcw className="mr-2 h-4 w-4" />
            <span>Manual Refunds</span>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('/campaigns')}>
            <Megaphone className="mr-2 h-4 w-4" />
            <span>Campaigns</span>
          </CommandItem>
        </CommandGroup>
        
        <CommandSeparator />
        
        {/* Settings & Developer */}
        <CommandGroup heading="Settings">
          <CommandItem onSelect={() => handleSelect('/settings')}>
            <Settings className="mr-2 h-4 w-4" />
            <span>Settings</span>
            <CommandShortcut>⌘,</CommandShortcut>
          </CommandItem>
          <CommandItem onSelect={() => handleSelect('https://joinfam.readme.io')}>
            <Code className="mr-2 h-4 w-4" />
            <span>Developer Hub</span>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};

export default CommandMenu;
